import {
  createContext,
  useContext,
  useState,
  ReactNode,
} from "react";

const IsReadOnlyContext = createContext<{readOnly: boolean, setToReadOnly: () => void, setToNotReadOnly: () => void}>({readOnly: false, setToReadOnly: () => {}, setToNotReadOnly: () => {}});

export function IsReadOnlyContextProvider({ children }: {children: ReactNode}) {
  const [readOnly, setReadOnly] = useState<boolean>(false);

  function setToReadOnly() {
    console.log("READ ONLY")
    setReadOnly(true)
  }

  function setToNotReadOnly() {
    console.log("NOT READ ONLY")
    setReadOnly(false)
  }

  return (
    <IsReadOnlyContext.Provider value={{readOnly, setToReadOnly, setToNotReadOnly}}>
      {children}
    </IsReadOnlyContext.Provider>
  );
}

export function useIsReadOnlyContextProviderContext() {
  const context = useContext(IsReadOnlyContext);

  if (!context) {
    throw new Error("setIsReadOnlyContextProviderContext must be used inside AppProvider");
  }

  return context;
}